import { autoGenQuestionResponseMock } from "./consts";

export const fetchAutoGeneratedQuestion = async (
  functionKey: string
): Promise<Response> => {
  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    // simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    return {
      ok: true,
      text: async () => autoGenQuestionResponseMock,
    } as Response; // cast to Response to satisfy TS
  }

  const apiRequest = `${process.env.REACT_APP_AUTO_GEN_QUESTION_URL}${functionKey}`;
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
};
